import { Box } from "@mui/material";
import { Button } from "src/components-mui/base/button/button";
import { IMAGE_BUTTON_VARIANTS } from "src/components-mui/base/image-button/constants";
import { ImageButton } from "src/components-mui/base/image-button/image-button";
import { HeroSliderButtonColor } from "src/components-mui/modules/hero-module/hero-slider-module.types";
import { ILink } from "src/types/common";
import { ValueOf } from "src/types/utils/value-of";

type ImageButtonVariant = ValueOf<typeof IMAGE_BUTTON_VARIANTS>;

export interface IHeroSlideCtaButton extends ILink {
    variant?: "solid" | "outline" | "image";
    colorScheme?: HeroSliderButtonColor | ImageButtonVariant;
}

interface IHeroSlideCtaButtonProps {
    cta: IHeroSlideCtaButton;
}

const HeroSlideCtaButton = ({ cta }: IHeroSlideCtaButtonProps) => {
    const { variant, url, target, colorScheme, name } = cta;
    if (variant === "image") {
        return <ImageButton url={url} target={target} imageVariant={colorScheme as ImageButtonVariant} />;
    }

    const correctedVariant = variant === "outline" ? "outlined" : "contained";
    return (
        <Button component="a" href={url} target={target} variant={correctedVariant} color={(colorScheme ?? undefined) as HeroSliderButtonColor}>
            {name}
        </Button>
    );
};

interface IHeroSlideCtaBoxProps {
    cta1?: IHeroSlideCtaButton | null;
    cta2?: IHeroSlideCtaButton | null;
}

export const HeroSlideCtaBox = ({ cta1, cta2 }: IHeroSlideCtaBoxProps) => {
    if (!cta1 && !cta2) {
        return null;
    }

    const isImageButtonsOnly = cta1?.variant === "image" && cta2?.variant === "image";

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: isImageButtonsOnly ? "row" : { xs: "column", sm: "column", md: "column", lg: "row" },
                gap: 2,
            }}
        >
            {cta1 && <HeroSlideCtaButton cta={cta1} />}
            {cta2 && <HeroSlideCtaButton cta={cta2} />}
        </Box>
    );
};
